import React from "react";
import { FaCalendarTimes } from "react-icons/fa";
import { NavLink, useLocation } from "react-router-dom";
import { IoDocuments } from "react-icons/io5";
import { BsFillCalendar2CheckFill, BsCalendarXFill } from "react-icons/bs";
import { BiSolidCalendarEdit } from "react-icons/bi";
import { TbCalendarRepeat } from "react-icons/tb";
import "./layout.css"; // Confirm file name

const LeaveLayout = ({ children }) => {
  const location = useLocation();

  const isLeaveReportActive = () => {
    const path = location.pathname;
    return (
      path === "/leave-report" ||
      path.startsWith("/leave-report/") ||
      path.startsWith("/emps-leave-reports") ||
      path.startsWith("/emps-leave-report")
    );
  };

  return (
    <div className="container-fluid">
      <h1 className="layouts-title">
        <FaCalendarTimes className="leave-policy-icon" />
        Leave Information
      </h1>
      <hr />

      <section>
        <div className="nav-container">
          <ul className="nav-list">
            <li className="nav-item">
              <NavLink
                to="/total-leave"
                className={({ isActive }) => `nav-link ${isActive ? "active" : ""}`}
              >
                <BiSolidCalendarEdit className="nav-icon" /> Total Leave
              </NavLink>
            </li>

            <li className="nav-item">
              <NavLink
                to="/pending-leave"
                className={({ isActive }) => `nav-link ${isActive ? "active" : ""}`}
              >
                <TbCalendarRepeat className="nav-icon" /> Pending Leave
              </NavLink>
            </li>

            <li className="nav-item">
              <NavLink
                to="/approved-leave"
                className={({ isActive }) => `nav-link ${isActive ? "active" : ""}`}
              >
                <BsFillCalendar2CheckFill className="nav-icon" /> Approved Leave
              </NavLink>
            </li>

            <li className="nav-item">
              <NavLink
                to="/rejected-leave"
                className={({ isActive }) => `nav-link ${isActive ? "active" : ""}`}
              >
                <BsCalendarXFill className="nav-icon" /> Rejected Leave
              </NavLink>
            </li>

            {/* Leave Report - Custom Active */}
            <li className="nav-item">
              <NavLink
                to="/leave-report"
                className={`nav-link ${isLeaveReportActive() ? "active" : ""}`}
              >
                <IoDocuments className="nav-icon" /> Leave Report
              </NavLink>
            </li>


            {/* Absent Management */}
            <li className="nav-item">
              <NavLink
                to="/absent-management"
                className={({ isActive }) => `nav-link ${isActive ? "active" : ""}`}
              >
                <IoDocuments className="nav-icon" /> Absent Management
              </NavLink>
            </li>
          </ul>
        </div>

        <div className="content">{children}</div>
      </section>
    </div>
  );
};

export default LeaveLayout;